import React from 'react';
import styled from '@emotion/styled';
import { PopupButton } from '@typeform/embed-react';
import { Colors, Typography } from '@zapier/design-system';

type Props = {
  id: string;
  name: string | null;
  buttonColor: string | null;
};

export const TypeformButton = (props: Props) => {
  const { id, name, buttonColor } = props;

  return (
    <Outer buttonColor={buttonColor}>
      <PopupButton id={id}>{name}</PopupButton>
    </Outer>
  );
};

const Outer = styled.article<{ buttonColor: string | null }>`
  text-align: center;
  > button {
    ${Typography.base}
    white-space: nowrap;
    background-color: ${({ buttonColor }) => buttonColor || Colors.ocean};
    color: ${Colors.white};
    font-size: 20px;
    border-radius: 10px;
    padding: 0 33px;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
    margin: 0;
    text-decoration: none;
  }
`;
